import styles from "./StaleContentModule.module.css";

import { CloseButtonDailyStoryFeedback } from "@/components/shared/CloseButtonSummary";
import { SmallRegenerateIcon } from "@/components/shared/icons/RegenerateIcon";

type Props = {
  onRegenerate: () => void;
  onClose: () => void;
};

export default function StaleContentModule(props: Props) {
  return (
    <div className={styles.main}>
      <div onClick={() => props.onClose()} className={styles.closeBtnDiv}>
        <CloseButtonDailyStoryFeedback />
      </div>
      <p className={styles.text}>
        Your scores have changed since this content was last generated.
      </p>
      <button onClick={() => props.onRegenerate()} className={styles.btn}>
        <SmallRegenerateIcon />
        Update content
      </button>
    </div>
  );
}
